import { FC, ReactNode } from 'react';
import styles from './index.less';


const Empty: FC<{ text?: ReactNode }> = ({ text = '暂无数据' }) =>
  <div className={styles.empty}>
    <span className={styles.emptyTip}>{text}</span>
  </div>

export default Empty;